import * as fromCompanySettingsReducer from '../reducers/company-settings.reducer';
import * as fromFeature from '../reducers';

import { CompanySettings } from '../../model/company-settings';
import { MemoizedSelector, createSelector } from '@ngrx/store';

export const getCompanySettingsSlice: MemoizedSelector<
  object,
  any
> = createSelector(
  fromFeature.getCompanyState,
  (state: fromFeature.CompanyState) => state.companySettings
);

export const getCompanySettings: MemoizedSelector<
  object,
  CompanySettings
> = createSelector(
  getCompanySettingsSlice,
  fromCompanySettingsReducer.getCompanySettingsEntity
);

export const getCompanySettingsLoading: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getCompanySettingsSlice,
  fromCompanySettingsReducer.getCompanySettingsLoading
);

export const getCompanySettingsLoaded: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getCompanySettingsSlice,
  fromCompanySettingsReducer.getCompanySettingsLoaded
);

export const saveCompanySettingsFail: MemoizedSelector<
  object,
  string
> = createSelector(
  getCompanySettingsSlice,
  fromCompanySettingsReducer.saveCompanySettingsFail
);

export const getCompanySettingsSaving: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getCompanySettingsSlice,
  fromCompanySettingsReducer.getCompanySettingsSaving
);

export const getCompanySettingsSaved: MemoizedSelector<
  object,
  boolean
> = createSelector(
  getCompanySettingsSlice,
  fromCompanySettingsReducer.getCompanySettingsSaved
);

export const getCompanySettingsSavedError: MemoizedSelector<
  object,
  string
> = createSelector(
  getCompanySettingsSlice,
  fromCompanySettingsReducer.getCompanySettingsSavedError
);

export const getCompanySettingsProperty: Function = (
  property: string
): MemoizedSelector<object, any> => {
  return createSelector(
    getCompanySettingsSlice,
    (state: fromCompanySettingsReducer.CompanySettingsState) => {
      return state.entity[property];
    }
  );
};
